import React, { useState } from 'react';
import Icon from '../../../../../../../muiComponents/Icon';
import useTranslate from '../../../../../../../customHooks/useTranslate';
import {
    useZitoneoServices,
    useZitoneoServicesStats,
} from '../../../../../contexts/ZitoneoContentContext';
import IconButton from '../../../../../../../muiComponents/IconButton';

const RequiredAttributesMissing = () => {
    const translate = useTranslate();
    const {
        handleVisibleServicesDetail,
        idVisibleServicesDetail,
        handleFocusHotelService,
    } = useZitoneoServices();
    const {
        requiredAtributesInCategory,
        requiredAtributesMissingInCategory,
        servicesInCategory,
    } = useZitoneoServicesStats();
    const [isDetailVisible, setIsDetailVisible] = useState(false);

    const serviceTypeCounters: Record<number, number> = {};
    const instanceNumberByHotelServiceId = servicesInCategory.reduce<
        Record<string, number>
    >((acc, service) => {
        serviceTypeCounters[service.IdServiceType] =
            (serviceTypeCounters[service.IdServiceType] || 0) + 1;
        acc[service.Id] = serviceTypeCounters[service.IdServiceType];

        return acc;
    }, {});

    const missingByService = requiredAtributesMissingInCategory.reduce<
        Record<
            string,
            {
                IdServiceType: number;
                ServiceType: string;
                InstanceName: string;
                definitions: string[];
            }
        >
    >((acc, item) => {
        if (!acc[item.IdHotelService]) {
            acc[item.IdHotelService] = {
                IdServiceType: item.IdServiceType,
                ServiceType: item.ServiceType,
                InstanceName: item.InstanceName,
                definitions: [],
            };
        }
        acc[item.IdHotelService].definitions.push(item.Definition.Name);
        return acc;
    }, {});

    if (!requiredAtributesInCategory.length) {
        return null;
    }

    if (!requiredAtributesMissingInCategory.length) {
        return (
            <li className='sidebar__quality_signal__item'>
                <div className='quality_signal__item__title'>
                    <Icon
                        iconName='Check'
                        style={{ color: 'var(--primary-400)' }}
                    />
                    <p>{translate('required_attributes_complete')}</p>
                </div>
                <div className='quality_signal__item__value --completed'>
                    {requiredAtributesInCategory.length} /{' '}
                    {requiredAtributesInCategory.length}
                </div>
            </li>
        );
    }

    return (
        <li className='sidebar__quality_signal__item --with-detail'>
            <div className='sidebar__quality_signal__item__header'>
                <div className='quality_signal__item__title'>
                    <Icon
                        iconName='WarningAmberOutlined'
                        className='quality_signal__item__icon'
                    />
                    <p>{translate('required_attributes_missing')}</p>
                </div>
                <div className='flex flex-align-center'>
                    <div className='quality_signal__item__value --error'>
                        {requiredAtributesMissingInCategory.length}
                    </div>
                    <IconButton
                        size='small'
                        iconName={
                            isDetailVisible ? 'ExpandMore' : 'ChevronRight'
                        }
                        onClick={() => setIsDetailVisible(!isDetailVisible)}
                    />
                </div>
            </div>
            {isDetailVisible ? (
                <ul className='sidebar__quality_signal__detail-list'>
                    {Object.entries(missingByService).map(([id, service]) => (
                        <li
                            key={id}
                            className='sidebar__quality_signal__detail-list__item'
                            role='button'
                            tabIndex={0}
                            onClick={() => {
                                handleFocusHotelService(id);
                                if (
                                    idVisibleServicesDetail !==
                                    service.IdServiceType
                                ) {
                                    handleVisibleServicesDetail(
                                        service.IdServiceType
                                    );
                                }
                            }}
                            onKeyDown={event => {
                                if (
                                    event.key === 'Enter' ||
                                    event.key === ' '
                                ) {
                                    event.preventDefault();
                                    handleFocusHotelService(id);
                                    if (
                                        idVisibleServicesDetail !==
                                        service.IdServiceType
                                    ) {
                                        handleVisibleServicesDetail(
                                            service.IdServiceType
                                        );
                                    }
                                }
                            }}
                        >
                            <Icon
                                iconName='FiberManualRecord'
                                style={{
                                    color: 'var(--error-700)',
                                    fontSize: '12px',
                                    flexShrink: 0,
                                    marginTop: '4px',
                                }}
                            />
                            <div>
                                <div className='sidebar__quality_signal__detail-list__title'>
                                    {service.ServiceType}
                                    {service.InstanceName
                                        ? ` · ${service.InstanceName}`
                                        : ` · #${
                                              instanceNumberByHotelServiceId[
                                                  id
                                              ] || 1
                                          }`}
                                </div>
                                <div className='sidebar__quality_signal__detail-list__meta'>
                                    {service.definitions.join(', ')}
                                </div>
                            </div>
                        </li>
                    ))}
                </ul>
            ) : null}
        </li>
    );
};

export default RequiredAttributesMissing;
